import { Button, Col, Form, Icon, message, Modal, Radio, Row, Spin, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import { FormComponentProps } from 'antd/lib/form'
import './HardwareRadioGroup.css';
import { AssetGroups } from '../../../configurable-fields';
import { downloadTempleteAsset, getAllAssetGroup, uploadAssetFile } from '../service';
import { UploadFile } from 'antd/lib/upload/interface';
import exportIcon from '../../../common-file/icon-file';

interface params {
    isOpenUploadAsset: boolean,
    setIsOpenUploadAsset: Function,
    fecthAssetList: Function
}
const fileSize = Number(process.env.REACT_APP_FILE_SIZE_UPLOAD)
type Props = FormComponentProps & params
const { Dragger } = Upload;
const DetailUploadAsset = (props: Props) => {
    const { getFieldDecorator } = props.form
    const [step, setStep] = useState(0)
    const [value, setValue] = useState<string | undefined>();
    const [assetType, setAssetType] = useState<AssetGroups[]>([])
    const [isLoadingAssetType, setIsLoadingAssetType] = useState(false)
    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false)
    const [fileList, setFileList] = useState<UploadFile[]>([])
    const [file, setFile] = useState<any>(null)

    useEffect(() => {
        fetchDataAssetGroup()
    }, [])

    useEffect(() => {
        if (!props.isOpenUploadAsset) {
            setStep(0)
            if (assetType.length > 0) {
                setValue(assetType[0].name)
            }
            setFileList([])
            setFile(null)
            setIsLoadingAssetType(false)
            setIsLoadingSubmit(false)
        }
    }, [props.isOpenUploadAsset])

    const fetchDataAssetGroup = () => {
        setIsLoadingAssetType(true)
        getAllAssetGroup().then((res) => {
            if (res) {
                setAssetType(res)
                setValue(res[0].name) // Set default value to the first asset group
            }
        }).finally(() => {
            setIsLoadingAssetType(false)
        })
    }

    function Warning(Text: string) {
        Modal.warning({
            title: 'Warning',
            content: Text,
            onOk: () => {
                setIsLoadingSubmit(false)
                props.fecthAssetList()
                // Modal.destroyAll()
            },
            className: 'modal-not-show-close'
        })
    }

    const handleSubmit = (e: any): void => {
        e.preventDefault()
        props.form.validateFields((err, values) => {
            if (!err) {
                setIsLoadingSubmit(true)
                // Handle the form submission logic here
                let Convertfile: File | null = null
                if (fileList[0] && fileList[0].originFileObj) {
                    const origin = fileList[0].originFileObj
                    if (origin instanceof File) {
                        Convertfile = origin
                    } else if (origin instanceof Blob) {
                        // Fallback: create a File from Blob if needed
                        Convertfile = new File([origin], fileList[0].name || 'upload.xlsx', { type: origin.type })
                    }
                }

                if ((Convertfile !== null || file) && value !== undefined) {
                    const findIdInOptions = assetType.find(option => option.name === value);                 
                    if (findIdInOptions) {
                        uploadAssetFile(Convertfile || file, findIdInOptions.id).then(() => {
                            Warning('This file is currently being imported and verified. Please wait.')
                        }).catch((err) => {
                            console.log('Error uploading file:', err)
                            setIsLoadingSubmit(false)
                            if (err?.response?.data?.status === 409 || err?.response?.status === 400) {
                                Warning(err?.response?.data?.message || err?.response?.message || 'The Another tenant is importing data. Please wait and try again.')
                            } else {
                                Warning('This file is currently being imported and verified. Please wait.')
                            }
                        }).finally(() => {
                            setIsLoadingSubmit(false)
                            setFileList([])
                            setFile(null)
                            setStep(0)
                            props.setIsOpenUploadAsset(false)
                        })
                    }
                }
            }
        })
    }

    const normFile = e => {
        setFile(e.file)
        setFileList(e.fileList)
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    const handleDownloadTemplate = () => {
        if (value) {
            const findIdInOptions = assetType.find(option => option.name === value);
            if (findIdInOptions) {
                downloadTempleteAsset(findIdInOptions.id, findIdInOptions.name)
            }
        }
    }

    const base64MimeType = (encoded: any) => {
        if (!encoded) return
        const mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/)
        if (mime && mime.length) return mime[1]
    }

    const uploadProps = {
        multiple: false,
        onRemove: (file: any) => {
            setFileList(state => {
                const index = state.indexOf(file)
                const newFileList = state.slice()
                newFileList.splice(index, 1)
                return newFileList
            })
        },
        beforeUpload: (file: any) => {
            const fileTypes = ['xlsx', 'csv']
            const extension = file.name.split('.').pop().toLowerCase()
            const isSuccess = fileTypes.indexOf(extension) < 0
            if (isSuccess) {
                setFile(null)
                setFileList([])
                message.error('You can only upload xlsx file!')
                return false
            }

            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onloadend = function (e: any) {
                console.log(e)
                if (file.size > fileSize) {
                    message.error('Maximum permitted size of 5 Mb')
                    return false
                }
                let fillOffFileList = fileList
                fillOffFileList.push({
                    uid: file.uid,
                    name: file.name,
                    status: 'done',
                    url: reader.result?.toString(),
                    type: base64MimeType(reader.result),
                    size: e.total,
                    thumbUrl: exportIcon(base64MimeType(reader.result))
                })
                fillOffFileList = fillOffFileList.slice(0)
                setFileList(fillOffFileList)
                console.log(fileList)
            }
            return false
        },
    }

    return (
        <div>
            <Spin spinning={isLoadingAssetType}>
                <Form onSubmit={handleSubmit} layout="vertical">
                    {
                        step === 0 && 
                        <div>
                            <Form.Item label="Selected Asset Group">
                                {getFieldDecorator('selected-group', {
                                    rules: [{ required: true, message: 'Please Select An Asset Group!' }],
                                })(
                                    <div className="radio-card-group upload-asset-step-1">
                                        <Radio.Group onChange={(e) => setValue(e.target.value)} value={value}>
                                            <Row gutter={[16, 16]}>
                                                {assetType.map((option) => (
                                                    <Col span={12}>
                                                        <label
                                                            key={option.name}
                                                            className={`radio-card ${value === option.name ? 'selected' : ''}`}
                                                        >
                                                            <Radio value={option.name} /> {option.name}
                                                        </label>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Radio.Group>
                                    </div>
                                )}
                            </Form.Item>
                            <Form.Item style={{ textAlign: 'right' }}>
                                <Button type="primary" htmlType="button" onClick={() => setStep(1)}>
                                    Next
                                </Button>
                            </Form.Item>
                        </div>
                    }
                    {
                        step === 1 && 
                        <div>
                            <Form.Item>
                                {getFieldDecorator('dragger', {
                                    valuePropName: 'fileList',
                                    getValueFromEvent: normFile,
                                })(
                                    <Dragger name="files" {...uploadProps} accept='.application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv, .xlsx'>
                                        <p className="ant-upload-drag-icon">
                                            <Icon type="inbox" />
                                        </p>
                                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                        <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                                    </Dragger>,
                                )}
                            </Form.Item>
                            <br/>
                            <div>If you do not have a file you can use the sample below</div>
                            <div>
                                <span className='feck-link' onClick={handleDownloadTemplate}><Icon type="download" /> Download Template </span>
                            </div>
                            <br/>
                            <Form.Item style={{ textAlign: 'right' }}>
                                <Button type="default" htmlType="button" onClick={() => setStep(0)}>
                                    Back
                                </Button>
                                <Button type="primary" htmlType="submit" style={{ marginLeft: '8px' }} loading={isLoadingSubmit} disabled={fileList.length === 0 || fileList.length > 1}>
                                    Import
                                </Button>
                            </Form.Item>
                        </div>
                    }
                </Form>
            </Spin>
        </div>
    )
}
const MyUploadAssetForm = Form.create<Props>({ name: 'MyUploadAssetForm' })(DetailUploadAsset)
export default MyUploadAssetForm